export const REACT_APP_AVCWISE_URL = process.env.REACT_APP_AVCWISE_URL;
